export default {
  cancelUnpaidCheckout: "Annulla",
  changeSelection: "Modifica la mia selezione",
  packIncludesBoost:
    "Include il boost di {{count}} giorni, che porta l’annuncio in cima alla sua categoria.",
  cartHeading: "Controlla i tuoi servizi",
  cartLead: "Tutti i servizi mostrati sono inclusi in un unico pagamento.",
  existingPayment:
    "C’è un pagamento in sospeso. Controlla le voci originali prima di pagare di nuovo.",
  resumePackagePayment: "Controlla il pagamento in sospeso",
  emptyCart: "Nessun servizio selezionato.",
  removeItem: "Rimuovi",
  currentCart: "Selezione attuale",
  reviewCartChanged:
    "La selezione è cambiata. Controlla le voci e accetta di nuovo le condizioni.",
  quoteExpiredCart:
    "Questo preventivo di promozione è scaduto. Scegli di nuovo la promozione dal tuo annuncio.",
  chooseAgain: "Scegli di nuovo",
  contextCreateAd: "Prezzo per un nuovo annuncio",
  contextMyAds: "Prezzo da I miei annunci",
  paymentOriginal: "Pagamento originale",
  viewCart: "Controlla i servizi selezionati",

  continueToCart: "Continua al pagamento unico",
  bankRateNote:
    "Paghi in euro. La tua banca applica il proprio tasso di cambio.",
  reverseVat: "Inversione contabile IVA · pagamento una tantum",
  checkout: "Continua al pagamento",
  resumePayment: "Riprendi il pagamento",
  storeReceipt: "Vedi la ricevuta dello store",
  title: "Dai più visibilità al tuo annuncio",
  lead: "Scegli visibilità a pagamento, un aspetto distintivo o entrambi.",
  boost: "Boost",
  boostDetail: "Spazi sponsorizzati a rotazione nelle ricerche pertinenti.",
  highlight: "Highlight",
  highlightDetail:
    "Una cornice verde discreta distingue il tuo annuncio senza cambiarne la posizione.",
  bundle: "Fatti notare",
  bundleDetail: "Boost e Highlight per sette giorni.",
  days: "{{count}} giorni",
  preview: "Anteprima del tuo annuncio",
  previewNote: "Un esempio dell’aspetto, non una posizione garantita.",
  choose: "Scegli un’opzione",
  continue: "Rivedi la promozione",
  notNow: "Non ora",
  total: "Totale",
  vat: "IVA inclusa · pagamento unico",
  saving: "Risparmia {{amount}} rispetto agli acquisti separati",
  terms:
    "Inizia quando l’annuncio è approvato e disponibile. Si sospende se non disponibile e termina alla vendita o al ritiro.",
  consent:
    "Accetto le condizioni e richiedo l’inizio quando il mio annuncio è idoneo.",
  pay: "Paga {{amount}}",
  paying: "Elaborazione…",
  error: "Qualcosa è andato storto. Riprova.",
  retry: "Riprova",
  unavailable:
    "Le promozioni non sono disponibili per questo annuncio al momento.",
  history: "Le tue promozioni",
  myAdsCta: "Promozioni",
  processingPayment: "Pagamento in elaborazione",
  activeUntil: "Fino al {{date}}",
  endedOn: "Terminata il {{date}}",
  report: "Risultati della campagna",
  impressions: "Impressioni visibili",
  clicks: "Clic",
  ctr: "Tasso di clic",
  noData: "Nessun dato disponibile",
  metricsNote:
    "Eventi registrati della campagna, non persone uniche né vendite aggiuntive. Metà scheda deve essere visibile per un secondo.",
  updated: "Aggiornato: {{date}}",
  start: "Inizio",
  end: "Fine",
  withdraw: "Ritira promozione",
  withdrawConfirm: "Interrompere questa promozione?",
  withdrawNote:
    "La pubblicazione si interrompe subito. Un eventuale rimborso viene valutato separatamente e non è garantito.",
  cancel: "Mantieni promozione",
  confirm: "Interrompi e richiedi verifica",
  back: "Torna ai miei annunci",
  sponsored: "Sponsorizzato",
  advertiser: "Pagato da {{name}}",
  reason: "Perché questo annuncio?",
  processing:
    "Stiamo verificando il pagamento sul server. Chiudere non annulla un pagamento completato.",
  refresh: "Aggiorna stato",
  paymentConfirmed: "Pagamento confermato",
  awaiting_payment: "In attesa del pagamento",
  awaiting_listing: "In attesa del tuo annuncio",
  active: "Attiva",
  paused: "In pausa",
  completed: "Completata",
  cancelled: "Annullata",
  refund_required: "Verifica necessaria",
  refunded: "Rimborsato",
  refund_requested: "Rimborso richiesto",
  pending: "In attesa",
  paid: "Pagato",
  failed: "Non riuscito",
  payment: "Pagamento",
  noCampaign: "Nessuna campagna. La tua prima promozione apparirà qui.",
  viewCampaign: "Vedi campagna",
  checking: "Verifica disponibilità…",
  expired: "Questo preventivo è scaduto. Aggiornalo prima di pagare.",
  noGuarantee: "Nessuna garanzia di posizione, impressioni o vendita.",
  previewFixture:
    "Anteprima locale · annuncio fittizio e dati di esempio · nessun acquisto",
  daily: "Attività giornaliera (UTC)",
  date: "Data",
  selected: "Selezionato",
  viewTerms: "Leggi le condizioni",
  termsTitle: "Condizioni della promozione",
  termsBody:
    "Servizio pubblicitario a pagamento unico. Gli spazi sponsorizzati ruotano tra annunci pertinenti; Highlight modifica solo l’aspetto. La durata conta solo durante l’idoneità. Il ritiro interrompe la pubblicazione e avvia una verifica umana del rimborso. I tuoi diritti legali restano invariati.",

  entryTitle: "Aiuta gli acquirenti giusti a scoprire il tuo articolo",

  entryBody:
    "Scegli come far notare il tuo annuncio, nelle ricerche e nella homepage.",

  entryCta: "Scopri le opzioni di promozione",

  editorTitle: "Promuovi il tuo annuncio",

  stepChoose: "Scelta",

  stepReview: "Riepilogo",

  stepPayment: "Pagamento",

  boostBenefit: "Fatti scoprire",

  highlightBenefit: "Attira l’attenzione",

  bundleBenefit: "Combina entrambi",

  boostBody: "Spazi sponsorizzati nelle ricerche pertinenti.",

  highlightBody:
    "Distingui il tuo annuncio con una cornice verde nei risultati di ricerca e nelle categorie.",

  bundleBody:
    "Visibilità sponsorizzata e cornice verde, insieme per sette giorni.",

  chooseDuration: "Scegli la durata",

  previewOriginal: "Il tuo annuncio",

  previewPromoted: "Con la tua promozione",

  selectionHint: "Scegli un’opzione per continuare",

  reviewTitle: "La tua promozione in breve",

  startsWhenReady: "Inizia quando il tuo annuncio è approvato e disponibile",

  pausesWhenNeeded:
    "Si sospende quando il tuo annuncio è temporaneamente indisponibile",

  trackResults: "Segui impressioni e clic in I miei annunci",

  close: "Chiudi",

  changeOption: "Cambia opzione",

  fromPrice: "Da {{amount}}",

  placementPreview: "Risultati sponsorizzati",

  appearancePreview: "Risultati di ricerca",

  previewEmpty: "Scopri come potrebbe apparire il tuo annuncio",

  oneTime: "Pagamento unico",

  reportListing: "Il tuo annuncio",

  viewListing: "Vedi annuncio",

  reportActivity: "Attività della promozione",

  reportAllTime: "Durante l’intera promozione",

  reportShown: "Visualizzazioni",

  reportShownHelp: "Il tuo annuncio promosso era visibile sullo schermo.",

  reportClicksHelp: "Clic sul tuo annuncio promosso.",

  reportRateHelp: "Clic divisi per le impressioni registrate.",

  reportChecked: "Report verificato il {{date}}",

  reportDaily: "Attività per giorno",

  reportPeriod: "Periodo del report",

  reportFullPeriod: "Intero periodo",

  reportLastDays: "Ultimi {{count}} giorni di attività",

  reportRecordedDays:
    "Sono mostrate solo le date con attività registrata. I giorni sono raggruppati in base all’ora UTC.",

  reportDataTable: "Vedi i dati giornalieri",

  reportNoActivity: "Nessuna attività registrata",

  reportEndedNoActivity:
    "Non è stata registrata alcuna attività prima dell’interruzione di questa promozione.",

  reportNoActivityBody:
    "Le impressioni e i clic registrati appariranno qui. I totali sopra mostrano quanto è stato misurato finora.",

  reportBeforeStart:
    "Il report inizierà con la pubblicazione della promozione.",

  reportPurchase: "La tua promozione",

  reportIncluded: "Incluso in questa promozione",

  reportAmount: "Importo dell’acquisto",

  reportPurchased: "Pagamento ricevuto",

  reportReference: "Riferimento della campagna",

  reportScheduledEnd: "Fine prevista",

  reportFinishedOn: "Terminata il",

  reportSupport: "Contatta l’assistenza",

  reportRefreshWarning:
    "Non è stato possibile aggiornare il report. Sono ancora visibili le ultime informazioni disponibili.",

  reportPollingStopped:
    "Siamo ancora in attesa di un aggiornamento del pagamento. I controlli automatici sono in pausa; aggiorna lo stato per verificare di nuovo.",

  reportResumeBody:
    "Riprendi il pagamento esistente. Se hai già pagato, aggiorna lo stato prima di riprovare.",

  reportPendingBody:
    "Il pagamento non è ancora confermato. Controlla il pagamento originale o lo store; non è necessario acquistare un’altra promozione.",

  reportActiveTitle: "La tua promozione è attiva",

  reportActiveBody:
    "I vantaggi scelti sono attivi finché il tuo annuncio è disponibile per gli acquirenti.",

  reportWaitingTitle: "Pronta quando lo sarà il tuo annuncio",

  reportWaitingBody:
    "Il pagamento è confermato. La promozione inizierà quando il tuo annuncio sarà approvato e disponibile. Il periodo pagato non è ancora iniziato.",

  reportPausedTitle: "La tua promozione è in pausa",

  reportPausedBody:
    "Il tuo annuncio è temporaneamente indisponibile. La promozione riprenderà quando sarà di nuovo disponibile e il tempo di pausa verrà aggiunto alla durata restante.",

  reportHolidayBody:
    "La promozione è sospesa mentre il tuo negozio è in vacanza. Il periodo pagato viene conservato fino a quando il tuo annuncio sarà di nuovo disponibile.",

  reportReservedBody:
    "Il tuo annuncio è prenotato. La promozione è sospesa durante la prenotazione; il periodo pagato viene conservato.",

  reportVerificationBody:
    "Stiamo verificando il tuo acquisto nello store. La promozione è sospesa e il periodo pagato viene conservato. Non è necessario acquistare di nuovo.",

  reportPlatformPauseBody:
    "Abbiamo temporaneamente sospeso la pubblicazione delle promozioni. Il periodo pagato viene conservato; non devi fare nulla.",

  reportApprovalBody:
    "Il tuo annuncio è in fase di verifica. La promozione inizierà o riprenderà quando sarà approvato e disponibile; l’attesa non riduce la durata della promozione.",

  reportFinishedTitle: "La tua promozione è terminata",

  reportFinishedBody:
    "Il periodo di promozione acquistato è terminato. Il report seguente mostra l’attività registrata durante la promozione.",

  reportSoldBody:
    "Il tuo articolo è stato venduto, quindi la promozione è terminata. L’attività seguente è quella registrata e non dimostra che la promozione abbia causato la vendita.",

  reportWithdrawnBody:
    "Il tuo annuncio non è più disponibile, quindi la promozione si è interrotta.",

  reportStoppedTitle: "La promozione è stata interrotta",

  reportStoppedBody:
    "Questa promozione non è più attiva. L’attività registrata e i dettagli dell’acquisto restano disponibili qui sotto.",

  reportReviewTitle: "La tua promozione richiede una verifica",

  reportReviewBody:
    "La promozione è stata interrotta mentre verifichiamo questo acquisto. Contatta l’assistenza se hai bisogno di aiuto; non è stato confermato alcun rimborso.",

  reportWithdrawalBody:
    "La tua richiesta è stata ricevuta e la promozione è stata interrotta. Un eventuale rimborso verrà valutato separatamente.",

  reportRefundedTitle: "Pagamento rimborsato",

  reportRefundedBody:
    "È stato confermato un rimborso e questa promozione non è più attiva.",

  reportNotFound: "Non abbiamo trovato questa promozione nel tuo account.",

  reportWithdrawalFailed:
    "Non è stato possibile confermare la richiesta. Questa finestra resta aperta per consentirti di riprovare. In caso di dubbio, controlla lo stato della campagna.",

  reportRequestReview: "Richiedi una verifica",

  reportReviewConfirm: "Richiedere una verifica di questa promozione?",

  reportReviewNote:
    "La promozione è già terminata. Valuteremo la tua richiesta separatamente; questo non garantisce un rimborso.",

  reportConfirmReview: "Invia richiesta di verifica",
  customPromotion: "La tua promozione",
  border: "Cornice",
  label: "Etichetta",
  homepage: "Spazio in homepage",
  fullBundle: "Pacchetto in evidenza",
  selectBundle: "Scegli Stand out",
  bundleIncludes: "Boost, Cornice ed Etichetta per 7 giorni",
  bundleSaving: "Risparmia {{amount}} rispetto agli acquisti separati",
  bundleRecommendation:
    "Ottieni 7 giorni di Boost, Cornice ed Etichetta a {{amount}} — meno di questa selezione.",
  borderBody: "Una cornice verde per la tua scheda.",
  labelBody: "La tua etichetta scelta come venditore.",
  homepageBody: "Schede sponsorizzate a rotazione in homepage.",
  homepageTerms:
    "Uno spazio a rotazione, non una posizione esclusiva. Nessuna garanzia di visualizzazioni o vendita.",
  homepageHeading: "Scopri di più",
  homepageContext: "In homepage",
  homepagePreviewNote:
    "La tua scheda entra in una selezione sponsorizzata a rotazione. Questa anteprima non promette una posizione fissa.",
  labelChoose: "Scegli un’etichetta",
  labelMustGo: "Da vendere",
  labelMovingSale: "Vendita per trasloco",
  labelInvoice: "Con fattura originale",
  labelCollect: "Pronto per il ritiro",
  labelAttestation:
    "Confermo che questa etichetta è veritiera per il mio annuncio.",
  labelPaidNote:
    "Scelta e pagata dal venditore. Non è una verifica di Whoppah.",
  labelRequired:
    "Scegli un’etichetta e conferma che è veritiera prima di continuare.",
  none: "Nessuno",
  addBenefit: "Aggiungi {{benefit}}",
  removeBenefit: "Rimuovi {{benefit}}",
  selectionUnavailable:
    "Questa selezione non è disponibile al momento. Cambia le opzioni o verifica di nuovo la disponibilità.",
  effectUnavailable: "Già attivo o non disponibile per questo annuncio",
  homepageSoldOut:
    "Gli spazi in homepage sono al completo. Scegli altri vantaggi o riprova più tardi.",
  checkAvailability: "Verifica disponibilità",
  mixedDurationNote:
    "Ogni vantaggio ha una propria durata. Lo spazio in homepage termina dopo 3 giorni; i vantaggi più lunghi continuano.",
  selectedBenefits: "I vantaggi selezionati",
  benefitStatus: "Stato di ogni vantaggio",
  placementsTitle: "Dove è apparsa la tua promozione",
  placementSearch: "Risultati di ricerca",
  placementCategory: "Risultati di categoria",
  placementCard: "Cornice ed etichetta sulle schede",
  placementHomepage: "Homepage",
  placementLegacyHighlight: "Schede evidenziate",
  placementOther: "Altro posizionamento",
  sharedExposureNote:
    "Una scheda può includere vantaggi di più acquisti. I totali contano le esposizioni registrate, non una copertura unica.",
  homepageCapacityWait:
    "Il pagamento è confermato. La promozione inizierà quando saranno disponibili uno spazio in homepage e il tuo annuncio. Il tempo pagato non è ancora iniziato.",
  labelSuppressed:
    "Questa etichetta è stata fermata per una verifica. Contatta l’assistenza per ricevere aiuto con l’acquisto.",
  newBenefits: "Aggiungi altri vantaggi promozionali",
  previewSearch: "Scheda di ricerca e categoria",
  previewHome: "Scheda della homepage",
  benefitEnd: "Fine prevista del vantaggio",
  benefitStarts: "Inizio del vantaggio",
  historicalBundle: "Boost e Highlight",
  bundleV2Body:
    "Boost, un bordo verde e la tua etichetta, insieme per 7 giorni.",
  customPromotionBody: "I tuoi vantaggi promozionali selezionati.",
  customPromotionBenefit: "Scegli i tuoi vantaggi",
  placementPartial:
    "I dettagli di posizionamento non sono disponibili per parte dell’attività registrata. Questa attività rimane inclusa nei totali della campagna.",
  reportSomeActiveBody:
    "Almeno un vantaggio è attivo. Controlla sotto lo stato e le date di ciascun vantaggio.",
  homepageWaitReview:
    "Nessuno spazio in homepage si è liberato entro il periodo di attesa. Questo acquisto richiede una verifica del rimborso; nessun rimborso è ancora confermato.",
  chooseBenefits: "Crea la tua promozione",
  selectionBenefitsHint: "Scegli una o più opzioni",
  termsBodyV2:
    "Questo è un servizio pubblicitario con pagamento unico. Gli spazi nella homepage ruotano. Cornice ed Etichetta modificano l’aspetto della scheda; le etichette sono scelte e confermate dal venditore, senza verifica di Whoppah. Ogni opzione dura per il periodo acquistato finché l’annuncio è idoneo. Un acquisto con spazio in homepage inizia quando sono disponibili sia uno spazio sia l’annuncio. Il ritiro interrompe la diffusione e avvia una valutazione umana del rimborso. I tuoi diritti legali restano invariati.",
  homepageStartFact:
    "Inizia quando il tuo annuncio e uno spazio in homepage sono disponibili",
  salesEyebrow: "FALLO RISALTARE",
  salesTitle: "Il buon design merita di essere visto.",
  salesBody: "Scegli un pacchetto o componi il tuo.",
  offerBoostBody: "Raggiungi gli acquirenti che cercano pezzi come il tuo.",
  offerBundleBody:
    "Più visibilità. Un aspetto distintivo. Tutto in un pacchetto.",
  offerHomeTitle: "Stand out + homepage",
  offerHomeBody:
    "Fatti notare nelle ricerche e attira l’attenzione di chi esplora la homepage.",
  offerBoostCta: "Scegli Boost",
  offerHomeCta: "Scegli il pacchetto",
  offerAllTogether: "Visibilità + stile",
  offerWiderReach: "Ricerca + homepage",
  offerSearchReach: "Visibilità nelle ricerche",
  offerRecommended: "La nostra scelta",
  offerMixedDuration: "Stand out 7 giorni · Homepage 3 giorni",
  offerSearchBenefit: "Spazi sponsorizzati nelle ricerche pertinenti",
  offerStyleBenefit: "Cornice verde + etichetta del venditore",
  offerResultsBenefit: "Segui impressioni e clic in I miei annunci",
  offerBundleBenefit: "Boost + Cornice + Etichetta",
  offerHomeBenefit: "Spazio a rotazione in homepage",
  offerSelected: "Selezionato",
  offerCustomize: "Scegli le singole opzioni",
  offerMakeYours: "La tua anteprima",
  offerPreviewBody: "Controlla la selezione prima di pagare.",
  completionOptional:
    "La promozione è facoltativa. Puoi sceglierla anche più tardi in I miei annunci.",
  individualOptionsBody: "Scegli una sola opzione o combina.",
  individualLink: "Vedi le singole opzioni",
  standOutTitle: "Fai risaltare il tuo annuncio",
  standOutLead:
    "Scegli una o più opzioni. Inizia quando il tuo annuncio è online e disponibile.",
  packDetail: "Boost di 7 giorni, cornice ed etichetta insieme.",
  bestValue: "Più conveniente",
  percentOff: "{{percent}}% di sconto",
  orSeparately: "oppure scegli separatamente",
  boostPickerDetail:
    "Il tuo annuncio torna in cima alla sua categoria. Parte non appena l’annuncio è online.",
  boostRunning:
    "Questo annuncio ha già un boost attivo. Potrai aggiungere un nuovo boost quando sarà terminato.",
  framePickerDetail:
    "Una cornice verde intorno al tuo annuncio nei risultati per 7 giorni.",
  labelMustGoTitle: "Etichetta «Da vendere»",
  previousPaymentProcessing:
    "Il tuo pagamento precedente è ancora in elaborazione. Riprova tra un minuto.",
  labelPickerDetail: "Una breve etichetta sul tuo annuncio per 7 giorni.",
  homepagePickerDetail:
    "Uno spazio sponsorizzato a rotazione sulla homepage per 3 giorni.",
  searchPreviewTitle: "Il tuo annuncio nei risultati di ricerca",
  searchPreviewLead:
    "Il tuo annuncio, con riquadri grigi per gli annunci vicini.",
  promotedTab: "Promosso",
  boostSummary: "Boost di {{count}} giorni",
  labelSummary: "Etichetta «{{text}}»",
  nothingSelected: "Nessuna selezione",
  continueWithPrice: "Continua al pagamento · {{price}}",
  goToMyAds: "Vai ai miei annunci",
  pricingContextChanged:
    "Lo sconto per i nuovi annunci non è più disponibile. I prezzi sono stati aggiornati.",
} as const;
